<!--
 * @Author: DQL
 * @Date: 2020-03-18 10:31:17
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:36:18
 * @Description: 机构管理--查看机构信息
 -->
<template>
  <div
    class="l-page--inner l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        详细信息
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <el-button
          type="primary"
          icon="kestrel-icon ki-plus"
          @click="handleAdd()"
        >
          新增下级组织
        </el-button>
        <el-button
          type="success"
          icon="kestrel-icon ki-edit"
          :disabled="disabledEditDept"
          @click="handleClickSwitchToEdit()"
        >
          编辑
        </el-button>
        <el-button
          type="danger"
          icon="kestrel-icon ki-trash-o"
          :disabled="disabledEditDept"
          @click="handleDel()"
        >
          删除
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <hm-page-card
        class="c-card--detail"
      >
        <el-form
          class="c-form"
          :inline="true"
          label-position="right"
          label-width="120px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              v-if="deptVo.parentDeptCode && deptVo.parentDeptName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级组织代码"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.parentDeptCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              v-if="deptVo.parentDeptName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级组织名称"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.parentDeptName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织代码"
                prop="deptCode"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.deptCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织名称"
                prop="deptName"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.deptName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                label="组织简称"
                class="c-form__item"
                prop="deptShortName"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.deptShortName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织标志"
                prop="deptType"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.deptTypeName }}
                </span>
              </el-form-item>
            </el-col>
            <!-- <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="有效期起"
                prop="effectStartDate"
              >
                <span
                  class="c-form__read"
                >
                {{ deptVo.effectStartDate | date('yyyy-MM-dd') }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="有效期止"
                prop="effectEndDate"
              >
                <span
                  class="c-form__read"
                >
                {{ deptVo.effectEndDate | date('yyyy-MM-dd') }}
                </span>
              </el-form-item>
            </el-col> -->
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="数据来源"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.sourceTypeName }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <!-- 页面主内容：详情 End -->
  </div>
</template>

<script>
import { deptService } from './dept.service';

export default {
  name: 'ViewDept',
  props: {
    deptVo: {
      type: Object,
      default () {
        return {
          parentDeptCode: null,
          parentDeptName: null,
          deptCode: null,
          deptName: null,
          deptShortName: null,
          deptTypeCode: null,
          effectStartDate: null,
          effectEndDate: null,
          source: null
        };
      }
    }
  },
  data () {
    return {};
  },
  computed: {
    // 禁止编辑的机构部门
    disabledEditDept () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.BASE_SOURCE_TYPE) {
        return this.deptVo.source === enums.BASE_SOURCE_TYPE.ENUM_KEY_1.id;
      }
      return false;
    }
  },
  methods: {
    /**
     * @description: 触发切换页面状态为新增
     * @param {*}
     * @return {*}
     */
    handleAdd () {
      this.$emit('switch', 'addDept');
    },
    /**
     * @description: 触发切换页面状态为编辑
     * @param {*}
     * @return {*}
     */
    handleClickSwitchToEdit () {
      this.$emit('switch', 'editDept');
    },
    /**
     * @description: 删除
     * @param {*}
     * @return {*}
     */
    handleDel () {
      const _this = this;
      _this.$confirm(`是否删除组织【${_this.deptVo.deptName}】？`, '提示', {
        type: 'warning'
      }).then(() => {
        deptService.delete(_this.deptVo.deptCode)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            // 回调重载页面
            _this.$emit('delReload');
          });
      });
    }
  }
};
</script>

<style>

</style>
